<div class="container">
  <h3 style="text-align: center; margin-top: 12px;">
    Profilo Travel Advisor QuoVado
  </h3>
  <div style="display: block; margin-bottom: -10px;">
    <app-ta-profile-form [user]="user" *ngIf="user"></app-ta-profile-form>
  </div>
</div>